function useFormatForGallery(contentResource) {
  if (!Array.isArray(contentResource) || contentResource?.length === 0) {
    return [];
  }

  return contentResource.map((img) => {
    const { file, title } = img.fields || {};
    const url = file?.url || '';
    const label = title || '';

    return {
      url,
      label,
      __typename: 'image',
      alt: label,
    };
  });
}

export default useFormatForGallery;
